(() => {
  const SELECTOR = '.vc-load-more__button';

  async function loadMore(button) {
    if (!button || button.classList.contains('is-loading')) return;

    const url = button.getAttribute('href');
    if (!url) return;

    const originalText = button.querySelector('.vc-load-more__label')?.textContent || '加载更多商品';
    button.classList.add('is-loading');
    const label = button.querySelector('.vc-load-more__label');
    if (label) label.textContent = '正在加载…';
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(url, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin'
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const incomingGrid = doc.querySelector('#product-grid');
      const currentGrid = document.querySelector('#product-grid');

      if (!incomingGrid || !currentGrid) throw new Error('Product grid not found');

      const fragment = document.createDocumentFragment();
      [...incomingGrid.children].forEach((item) => fragment.appendChild(item));
      currentGrid.appendChild(fragment);

      const incomingButton = doc.querySelector(SELECTOR);
      if (incomingButton?.getAttribute('href')) {
        button.setAttribute('href', incomingButton.getAttribute('href'));
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        if (label) label.textContent = originalText;
      } else {
        const wrap = button.closest('.vc-load-more-wrap');
        if (wrap) wrap.remove();
      }

      document.dispatchEvent(new CustomEvent('vc:collection:products-appended'));
    } catch (error) {
      console.warn('[VC collection] Load more failed; falling back to navigation.', error);
      window.location.href = url;
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest(SELECTOR);
    if (!button) return;
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    event.preventDefault();
    loadMore(button);
  });
})();
(() => {
  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

  function syncSheetState() {
    const disclosure = document.querySelector('#main-collection-filters details.mobile-facets__disclosure');
    const open = Boolean(disclosure?.open) && isMobile();
    document.documentElement.classList.toggle('vc-facets-open', open);
  }

  document.addEventListener('change', (event) => {
    const input = event.target.closest('.vc-mobile-sort__option input[type="radio"]');
    if (!input) return;
    const details = input.closest('.vc-mobile-sort');
    const label = details?.querySelector('.vc-mobile-sort__current');
    const selectedText = input.closest('.vc-mobile-sort__option')?.querySelector('span')?.textContent?.trim();
    if (label && selectedText) label.textContent = selectedText;
  });

  document.addEventListener('toggle', (event) => {
    if (event.target.matches?.('#main-collection-filters details.mobile-facets__disclosure')) {
      syncSheetState();
    }
  }, true);

  document.addEventListener('click', (event) => {
    if (event.target.closest('#main-collection-filters .mobile-facets__open-wrapper, #main-collection-filters .vc-mobile-facets__sheet-close, #main-collection-filters .vc-mobile-facets__actions .button')) {
      requestAnimationFrame(syncSheetState);
      setTimeout(syncSheetState, 40);
    }
  });

  window.addEventListener('resize', syncSheetState, { passive: true });
  syncSheetState();
})();
